import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgColEllipsis = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 4,
	viewBox: "0 0 14 4",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M10.9375 1.75C10.9375 2.48828 11.5117 3.0625 12.25 3.0625C12.9609 3.0625 13.5625 2.48828 13.5625 1.75C13.5625 1.03906 12.9609 0.4375 12.25 0.4375C11.5117 0.4375 10.9375 1.03906 10.9375 1.75ZM3.0625 1.75C3.0625 1.03906 2.46094 0.4375 1.75 0.4375C1.01172 0.4375 0.4375 1.03906 0.4375 1.75C0.4375 2.48828 1.01172 3.0625 1.75 3.0625C2.46094 3.0625 3.0625 2.48828 3.0625 1.75ZM8.3125 1.75C8.3125 1.03906 7.71094 0.4375 7 0.4375C6.26172 0.4375 5.6875 1.03906 5.6875 1.75C5.6875 2.48828 6.26172 3.0625 7 3.0625C7.71094 3.0625 8.3125 2.48828 8.3125 1.75Z",
		fill: "#B0BEC5"
	})]
});
const ForwardRef = forwardRef(SvgColEllipsis);
export { ForwardRef as ReactComponent };
